<template>
  <v-container>
    <v-slide-x-transition>
      <v-data-table
        :headers="cmp_headers"
        :items="cmp_items"
        class="elevation-1"
        :loading="cmpLoading"
        loading-text="Загружаю данные"
        item-key="COMP_ID"
        show-select
        single-select
        :search="compSearch"
        :value="value"
        @input="setValue"
        locale="ru-RU"
        dense
      >
        <template v-slot:top>
          <v-toolbar color="primary" dark dense>
            <v-toolbar-title>Компоненты</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="compSearch"
              append-icon="mdi-magnify"
              label="Искать"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`item.COMP_PRICE`]="{ item }">
          {{ numLocaleDecorator(item.COMP_PRICE) }}
        </template>
        <template v-slot:[`item.COMP_LOWER_LIMIT`]="{ item }">
          {{ numLocaleDecorator(item.COMP_LOWER_LIMIT) }}
        </template>
        <template v-slot:[`item.COMP_UPPER_LIMIT`]="{ item }">
          {{ numLocaleDecorator(item.COMP_UPPER_LIMIT) }}
        </template>
        <template v-slot:[`item.COMP_STEP`]="{ item }">
          {{ numLocaleDecorator(item.COMP_STEP) }}
        </template>
        <template v-slot:no-data>
          Нет данных
        </template>
      </v-data-table>
    </v-slide-x-transition>
  </v-container>
</template>

<script>
import { RCPT_GET_COMPONENTS } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'

export default {
  name: 'componentsTable',
  props: ['value', 'project'],
  mixins: [numDecorator],
  components: {
  },
  data () {
    return {
      cmp_headers: [
        { text: 'Наименование', value: 'COMP_NAME' },
        { text: 'Код', align: 'end', value: 'COMP_CODE' },
        { text: 'Цена, р.', align: 'end', value: 'COMP_PRICE' },
        { text: 'Нижний предел, %', align: 'end', value: 'COMP_LOWER_LIMIT' },
        { text: 'Верхний предел, %', align: 'end', value: 'COMP_UPPER_LIMIT' },
        { text: 'Шаг', align: 'end', value: 'COMP_STEP' }
      ],
      cmpLoading: false,
      compSearch: '',
      cmp_items: []
    }
  },
  watch: {
    value (val) {
      console.log('componentsTable value changed to ', val)
      if (!val || !val.length || !val[0].COMP_ID) return
      const curr = this.cmp_items.findIndex(itm => itm.COMP_ID === val[0].COMP_ID)
      if (curr >= 0) {
        if (val[0].action === 'delete') {
          this.cmp_items.splice(curr, 1)
          return
        }
        this.cmp_items.splice(curr, 1, val[0])
      } else {
        this.cmp_items.push(val[0])
      }
    },
    project (val) {
      console.log('componentsTable project changed to ', val)
      this.getCmpList()
    }
  },
  computed: {
  },
  mounted: function () {
    console.log('componentsTable mounted with component ', this.value)
    if (this.cmp_items.length === 0) {
      this.getCmpList()
    }
  },
  methods: {
    setValue (val) {
      this.$emit('input', val)
    },
    getCmpList () {
      this.cmpLoading = true
      this.$store.dispatch(RCPT_GET_COMPONENTS, { ULF_ID: this.project.ULF_ID || null })
        .then((res) => {
          this.cmp_items.splice(0, this.cmp_items.length, ...res)
          this.setValue([])
        })
        .catch((err) => {
          this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка компонентов: \n ${err}` })
        })
        .finally(() => {
          this.cmpLoading = false
        })
    }
  }
}
</script>
